import { Loader2, RotateCcw } from "lucide-react";

import { Button, type ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface RetryButtonProps {
  onRetry: () => void;
  /** Shows a spinner and disables the button while a retry is in flight. */
  pending?: boolean;
  label?: string;
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
  className?: string;
}

/** The one retry button every feedback component uses — so "trying again"
 * always looks and behaves the same way anywhere in the studio. */
export function RetryButton({
  onRetry,
  pending = false,
  label = "Try again",
  size = "sm",
  variant = "outline",
  className,
}: RetryButtonProps) {
  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      onClick={onRetry}
      disabled={pending}
      className={cn(className)}
    >
      {pending ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <RotateCcw className="h-3.5 w-3.5" />
      )}
      {label}
    </Button>
  );
}
